export const cartActionTypes = {
    CART_REQUESTED: 'CART_REQUESTED',
    CART_RECEIVED: 'CART_RECEIVED',
    CART_FAILED: 'CART_FAILED',
    CART_ADD_PRODUCT: 'CART_ADD_PRODUCT',
    CART_ADD_DDD: 'CART_ADD_DDD',
    CART_DELETE_ITEM: 'CART_DELETE_ITEM',
    CART_QTY_UPDATE: 'CART_QTY_UPDATE',
    CART_TOGGLE_PROCESS_TYPE: 'CART_TOGGLE_PROCESS_TYPE',
    CART_UPDATE_CHECKOUT: 'CART_UPDATE_CHECKOUT',
    CART_UPDATE_SHIPPING: 'CART_UPDATE_SHIPPING',
    CART_UPDATE_SHIPPING_REQUESTED: 'CART_UPDATE_SHIPPING_REQUESTED',
    CART_CHECKOUT_SUCCESS: 'CART_CHECKOUT_SUCCESS',
    CART_CHECKOUT_FAILED: 'CART_CHECKOUT_FAILED',
    CART_CHECKOUT_ACKNOWLEDGED: 'CART_CHECKOUT_ACKNOWLEDGED',
    DEFAULT_PAYMENT_CHANGED: 'DEFAULT_PAYMENT_CHANGED',
    CART_APPROVE_RPC: 'CART_APPROVE_RPC',
    CART_DUE_DATE_REQUESTED: 'CART_DUE_DATE_REQUESTED',
    CART_PROCESS_TYPE_CHOICE_MADE: 'CART_PROCESS_TYPE_CHOICE_MADE',
    CART_PROCESS_AI_CHOICE_MADE: 'CART_PROCESS_AI_CHOICE_MADE',
    CART_TOGGLE_AI_TYPE: 'CART_TOGGLE_AI_TYPE'
};


// WEBPACK FOOTER //
// ./src/cart/actions/cart-action-types.js